export default __webpack_public_path__ + "static/media/balkouras-nicos-8tadBT_8Gag-unsplash-small.ac40f0ab.jpg";